export enum ShmiraListActionType {
  Rename = 1,
  Delete = 2,
  ManageShmiraListim = 3,
  CreateCopy = 4,
  Archive = 5,
  CreateNew = 6,
  ImportPreferences = 7,
}

export enum ShmiraListManagementActionType {
  Rename = 1,
  MoveToTrash = 2,
  MoveToArchive = 3,
  MoveToActive = 4,
  DeleteForever = 5,
  EmptyTrash = 6,
}
